(function () {
  function selectedId() {
    var on = document.querySelector('.venj-pack.is-on input[name="id"]');
    return on ? on.value : null;
  }
  function select(id) {
    if (!id) return;
    document.querySelectorAll('.venj-pack').forEach(function (pack) {
      var input = pack.querySelector('input[name="id"]');
      var on = input && input.value === String(id);
      pack.classList.toggle('is-on', !!on);
      if (input) input.checked = !!on;
    });
  }
  function bindGallery(root) {
    var track = root.querySelector('[data-venj-track]');
    if (!track) return;
    var thumbs = [].slice.call(root.querySelectorAll('[data-venj-thumb]'));
    var i = 0;
    function go(n) {
      var slides = track.children.length;
      i = (n + slides) % slides;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = root.querySelector('[data-venj-prev]');
    var next = root.querySelector('[data-venj-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    var tmr;
    track.addEventListener('scroll', function () {
      clearTimeout(tmr);
      tmr = setTimeout(function () {
        var n = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (n !== i) {
          i = n;
          thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        }
      }, 60);
    }, { passive: true });
  }
  function bindReviews(root) {
    var track = root.querySelector('[data-venj-rev]');
    if (!track) return;
    var prev = root.querySelector('[data-venj-rev-prev]');
    var next = root.querySelector('[data-venj-rev-next]');
    function step(dir) {
      var card = track.querySelector('.venj-card');
      var w = card ? card.getBoundingClientRect().width + 16 : 320;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }
  function init() {
    document.querySelectorAll('[data-venj-hero]').forEach(bindGallery);
    document.querySelectorAll('[data-venj-reviews]').forEach(bindReviews);
    document.querySelectorAll('.venj-pack input[name="id"]').forEach(function (input) {
      input.addEventListener('change', function () { if (input.checked) select(input.value); });
    });
    var checked = document.querySelector('.venj-pack input[name="id"]:checked');
    if (checked) select(checked.value);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
